/** Purchase order numbers: PO-YYYYMMDD-01, counted per local day. */

export function purchaseOrderDateStamp(now = new Date()): string {
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  return `${year}${month}${day}`;
}

/** Next id for this local day. Older timestamp ids (PO-1790…) are ignored. */
export function nextPurchaseOrderId(existingIds: string[], now = new Date()): string {
  const dateStr = purchaseOrderDateStamp(now);
  const prefix = `PO-${dateStr}-`;
  let max = 0;
  for (const id of existingIds) {
    if (!id.startsWith(prefix)) continue;
    const sequence = Number(id.slice(prefix.length));
    if (Number.isInteger(sequence) && sequence > max) max = sequence;
  }
  return `${prefix}${String(max + 1).padStart(2, '0')}`;
}

/** Used when a create collides; keeps the same day and steps the sequence. */
export function bumpPurchaseOrderId(id: string): string {
  const match = id.match(/^PO-(\d{8})-(\d+)$/);
  if (!match) return nextPurchaseOrderId([], new Date());
  const next = Number(match[2]) + 1;
  return `PO-${match[1]}-${String(next).padStart(2, '0')}`;
}
